import axios, { encodeData } from "../utils/axios";

export const fetchApplicationStatus = async () => {
  const res = await axios.get("/applicationStatus").catch((error) => {
    if (error.response) {
      console.error(error);
    }
  });

  return res.data;
};

export const createApplicationStatus = async (newApplicationStatus) => {
  await axios.post(
    "/applicationStatus/create",
    encodeData(newApplicationStatus)
  );
};

export const updateApplicationStatus = async (updatedApplicationStatus) => {
  await axios.put(
    "/applicationStatus/update",
    encodeData(updatedApplicationStatus)
  );
};

export const deleteApplicationStatus = async (oldApplicationStatus) => {
  await axios.delete("/applicationStatus/delete", {
    data: encodeData(oldApplicationStatus),
  });
};
